import React, { useState, useRef } from "react";
import "../../css/CRUDModal.css";
import { ICONS } from "../../assets/Icons";
import SuccessModal from "../successModal/successModal";
import useExcelDownloader from "../../Hooks/useExcelDownloader";

const RcsBulkMessageModal = ({
  show,
  handleClose,
  setIsBulkUpload,
  setBulkFileName,
  csvFile,
  setCsvFile,
  bulkType,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const { downloadExcel } = useExcelDownloader();
  const fileInputRef = useRef(null);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setsuccessMessage] = useState("");

  const [formData, setFormData] = useState({
    username: loggedInUserName,
  });
  const [errors, setErrors] = useState({
    senderId: "",
    entityId: "",
    templateId: "",
    csv: "",
  });

  const handleAddUser = (e) => {
    e.preventDefault();
    handleClose();
  };

  const handleBack = () => {
    handleClose();
    haldleSetEmptyField();
  };

  const haldleSetEmptyField = () => {
    setFormData({
      username: "",
    });
    setCsvFile(null);
    setErrors({});
  };

  const header1 = [
    { key: "SrNo", label: "SrNo" },
    { key: "MobileNo", label: "MobileNumber" },
  ];

  const header2 = [
    { key: "SrNo", label: "SrNo" },
    { key: "MobileNo", label: "MobileNumber" },
    { key: "Name", label: "Name" },
  ];

  const headers = bulkType === "name" ? header2 : header1;

  const data = [{ SrNo: "", MobileNo: "", Template: "" }];

  const handelDownloadExcelFormat = () => {
    downloadExcel(data, headers, "BulkMessageFormat.xlsx");
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    setCsvFile(e.target.files[0]);
    setBulkFileName(e.target.files[0]);
    setIsBulkUpload(true);
    setErrors({});
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    handleClose(false);
  };

  const isDisabled = false;

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "597px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">Bulk Upload</h5>
              </div>
              <form onSubmit={(e) => handleAddUser(e)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <div className="row mb-3 mt-3">
                    <div
                      className="col-md-6"
                      style={{ width: "98%", marginTop: "24px" }}
                    >
                      <div
                        style={{
                          borderRadius: "10px",
                          border: "1px dashed #00B6CE",
                          padding: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#F6F6F6",
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          opacity: isDisabled ? 0.6 : 1,
                        }}
                        onClick={!isDisabled ? triggerFileInput : undefined}
                      >
                        <div>
                          <p
                            style={{
                              margin: 0,
                              color: "#454545",
                              fontSize: "16px",
                            }}
                          >
                            Upload from your computer
                          </p>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "12px",
                              color: "#6D6D6D",
                            }}
                          >
                            .XLSX files <br />
                            <span>{csvFile?.name}</span>
                          </p>
                        </div>
                        <img
                          src={ICONS.UploadCsvIcon}
                          alt="uploadCsv"
                          style={{ width: "31px" }}
                        />
                        <input
                          type="file"
                          accept=".xlsx"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          className="hidden"
                          style={{ display: "none" }}
                        />
                      </div>
                      {errors.csv ? (
                        <span className="error">{errors.csv}</span>
                      ) : null}
                    </div>

                    <div
                      className="col-md-6"
                      style={{
                        width: "98%",
                        marginTop: "24px",
                        display: "flex",
                        alignItems: "center",
                        gap: "13px",
                        cursor: "pointer",
                      }}
                      onClick={handelDownloadExcelFormat}
                    >
                      <img
                        src={ICONS.DownloadCsvIcon}
                        alt="downloadCsv"
                        style={{ width: "31px" }}
                      />
                      <p
                        style={{
                          margin: 0,
                          color: "#1A1A1A",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "color 0.3s, text-decoration 0.3s",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = "#00B6CE";
                          e.target.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "#1A1A1A";
                          e.target.style.textDecoration = "none";
                        }}
                      >
                        Download Sample Template
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingTop: "0px",
                    gap: "16px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                    style={{ width: "150px", height: "52px" }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit"
                    style={{
                      width: "150px",
                      height: "52px",
                      cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                    disabled={isDisabled}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          {showSuccessModal && (
            <SuccessModal
              show={showSuccessModal}
              handleClose={handleCloseModal}
              successMessage={successMessage}
            />
          )}
        </div>
      )}
    </>
  );
};

export default RcsBulkMessageModal;
